
import { mapState, mapGetters } from 'vuex';
import statsMixin from '@/mixins/statsMixin';
import storeMixin from '@/mixins/storeMixin';
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [statsMixin, uiMixin, storeMixin],
  mounted() {
    if (this.$posthog.isFeatureEnabled('add-posthog-marketplace')) {
      this.$posthog.capture('home_page_viewed');
    }
    // this.$vuetify.rtl = this.$i18n.locale === 'ar';
  },
  computed: {
    ...mapState({
      products: (state) => state.products.list,
    }),
    ...mapGetters('posts', ['getBlogPosts']),
  },
  methods: {
    moveToExploreMore() {
      this.$posthog.capture('explore_more_clicked');
      const element = this.$refs.exploreProducts.$el;
      element.scrollIntoView({ behavior: 'smooth' });
    },
    moveToLearnMore() {
      this.$posthog.capture('learn_more_clicked');
      this.$router.push('/apps/expression-base');
    },
  },
};
